const PromotionIcon = ({
  color = "#2B363B",
  width = 20,
  height = 21,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Icono promoción"
    {...props}
  >
    <path
      d="M7.5 14.8974C7.5 14.8974 13.3333 15.7307 15.8333 18.2307H16.6667C16.8877 18.2307 17.0996 18.1429 17.2559 17.9866C17.4122 17.8304 17.5 17.6184 17.5 17.3974V12.3449C17.8581 12.2528 18.1755 12.0442 18.4021 11.752C18.6287 11.4598 18.7516 11.1005 18.7516 10.7307C18.7516 10.3609 18.6287 10.0016 18.4021 9.70942C18.1755 9.4172 17.8581 9.20863 17.5 9.11655V4.06405C17.5 3.84303 17.4122 3.63107 17.2559 3.47479C17.0996 3.31851 16.8877 3.23071 16.6667 3.23071H15.8333C13.3333 5.73071 7.5 6.56405 7.5 6.56405H4.16667C3.72464 6.56405 3.30072 6.73964 2.98816 7.0522C2.67559 7.36476 2.5 7.78869 2.5 8.23071V13.2307C2.5 13.6727 2.67559 14.0967 2.98816 14.4092C3.30072 14.7218 3.72464 14.8974 4.16667 14.8974H5L5.83333 19.064H7.5V14.8974ZM9.16667 7.94821C9.73583 7.82655 10.4392 7.65655 11.2 7.43405C12.5983 7.02238 14.375 6.37488 15.8333 5.37571V16.0849C14.375 15.0865 12.5975 14.439 11.2 14.0274C10.5288 13.8312 9.85055 13.66 9.16667 13.514V7.94821ZM4.16667 8.23071H7.5V13.2307H4.16667V8.23071Z"
      fill={color}
    />
  </svg>
);

export default PromotionIcon;
